import { Link, Text } from '@/theme/components';
import { HouseConditionOption, HouseConditionValues } from './types';

export const houseConditionOptions: HouseConditionOption[] = [
  {
    text: 'Property is not my full-time residence',
    value: 'not_full_time_residence',
  },
  { text: 'Pre-existing damage to property', value: 'pre_existing_damage' },
  {
    text: 'Business conducted in property entails foot traffic',
    value: 'not_important',
  },
  { text: 'Unit is occupied by more than 1 family', value: 'unit_occupied' },
  { text: 'Dwelling is vacant', value: 'dwelling_vacant' },
  { text: 'None of these apply', value: 'none_apply' },
];

export const defaultCheckBoxValues: Record<HouseConditionValues, boolean> = {
  not_full_time_residence: false,
  pre_existing_damage: false,
  not_important: false,
  unit_occupied: false,
  dwelling_vacant: false,
  none_apply: false,
};

export const disclaimers = (brandName: string) => (
  <>
    <Text variant="body2">
      ”Disclaimer: We take your privacy seriously. By clicking submit, you agree
      by electronic signature to the{' '}
      <Link
        target="_blank"
        href={`https://www.${brandName}.com/terms-and-conditions`}
      >
        Terms of Use
      </Link>{' '}
      and{' '}
      <Link target="_blank" href={`https://www.${brandName}.com/privacy`}>
        Privacy Policy
      </Link>
      . Furthermore, you agree and provide express consent for {brandName} and
      our partners or one of their third party partners to contact you about
      their respective service offers at the number and/or email you entered,
      including through the use of an autodialer, prerecorded message, text
      message (SMS/MMS), and/or email, even if you number is on a corporate,
      state or national Do Not Call Registry. You will only be contacted for
      specific services that you have selected, which include partners, their
      networks and clients for: real estate agent professionals, financial
      services, home insurance, home security services, home warranty, solar
      energy services, energy and utility services, property tax services, home
      improvement and contractors. You do not have to agree to be contacted in
      order to purchase any services or goods from our partners. You further
      agree that we can share your personal data with our third party partners,
      such as our partners, service providers and other affiliates, and that we
      can use this data for marketing and analytics, and to make your experience
      better.”
    </Text>
    <Text variant="body2">
      * No purchase necessary. Request a free, no-obligation home insurance
      quote with Bubble Insurance Solutions (“Bubble”) for a complimentary $5
      e-gift card. User must request the quote by calling Bubble's customer
      service or by selecting and customizing the quote on Bubble-powered
      website. Must be of legal age where residing. Maximum $5 award per
      household per email address even if multiple quotes requested. Offer not
      valid when a Bubble-issued policy is already in force, or in states where
      Bubble is not licensed. E-gift cards are issued by Bubble Insurance
      Solutions and subject to the issuer's terms and conditions.
    </Text>
  </>
);
